<template>
  <div class="col-md-12 p-0">
    <div class="card">
      <div class="card-body">
        <!-- ===================== -->
        <!-- STEP 1 : LIST CONTRACT -->
        <!-- ===================== -->
        <div v-if="!selectedContract">
          <h5 class="mb-4">Daftar Kontrak</h5>

          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead class="thead-light">
                <tr>
                  <th>Action</th>
                  <th>Contract Number</th>
                  <th>Client Name</th>
                  <th>Contract Period</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="contract in contracts" :key="contract.id">
                  <td width="130">
                    <!-- <button
                      class="btn btn-sm btn-primary"
                      @click="selectContract(contract)"
                    >
                      Feedback
                    </button> -->
                    <button
                      class="btn btn-sm btn-primary"
                      @click="openFeedbackPeriod(contract)"
                    >
                      Feedback
                    </button>
                    <button
                      v-if="contract.feedbacks.length > 0"
                      class="btn btn-danger btn-sm"
                      @click="openPdfPeriod(contract)"
                    >
                      PDF
                    </button>
                  </td>
                  <td>{{ contract.contract_number }}</td>
                  <td>{{ contract.client.name }}</td>
                  <td>
                    {{ contract.start_date | moment("YYYY-MM-DD") }} -
                    {{ contract.end_date | moment("YYYY-MM-DD") }}
                  </td>
                  <td>
                    <!-- <span class="badge badge-success">
                      {{ contract.status }}
                    </span> -->
                    <span :class="contract.status | contractStatus">
                      {{ contract.status | cleanString }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ===================== -->
        <!-- STEP 2 : AREA FEEDBACK -->
        <!-- ===================== -->
        <div v-else>
          <div class="d-flex justify-content-between mb-3">
            <!-- <h5>Feedback Area - {{ selectedContract.contract_number }}</h5>
            <br />
            <h4>
              Periode Penilaian dari -
              <strong>{{ this.selectedFeedbackMonths.join(", ") }}</strong>
            </h4> -->
            <button class="btn btn-sm btn-secondary" @click="backToPeriod">
              ← Kembali
            </button>
          </div>

          <!-- <div v-if="isUpdateMode" class="alert alert-info">
            Anda sudah pernah mengisi feedback. Anda dapat memperbarui feedback
            jika diperlukan.
          </div> -->

          <!-- <div
            v-if="completedSelectedMonths.length"
            class="alert alert-warning"
          >
            <strong> Perhatian! </strong>

            Beberapa periode yang dipilih telah memiliki feedback.

            <ul style="margin-top: 8px">
              <li v-for="month in completedSelectedMonths" :key="month">
                {{ formatMonth(month) }}
              </li>
            </ul>

            Feedback pada periode tersebut akan diperbarui.
          </div> -->
          <div class="feedback-period-header">
            <div>
              <small> Feedback Period </small>
              <h3>
                {{ selectedMonthsText }}
              </h3>
            </div>
          </div>

          <div
            v-if="completedSelectedMonths.length"
            class="feedback-warning-card"
          >
            <div class="warning-icon">🔄</div>

            <div class="warning-content">
              <h4>Feedback Update Notice</h4>
              <p>
                Anda memilih
                <strong>
                  {{ selectedFeedbackMonths.length }}
                </strong>
                periode penilaian.
              </p>

              <div class="row">
                <div class="col-md-6">
                  <h5 style="color: #16a34a">✔ Feedback Baru</h5>
                  <ul>
                    <li v-for="month in newSelectedMonths" :key="month">
                      {{ formatMonth(month) }}
                    </li>
                  </ul>
                </div>

                <div class="col-md-6">
                  <h5 style="color: #ea580c">🔁 Akan Diperbarui</h5>
                  <ul>
                    <li v-for="month in completedSelectedMonths" :key="month">
                      {{ formatMonth(month) }}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <small style="font-size: 14px">
                Feedback pada periode yang sudah ada akan diperbarui. Periode
                lainnya akan dibuat sebagai feedback baru.
              </small>
            </div>
          </div>

          <!-- Progress -->
          <div class="progress mb-4">
            <div
              class="progress-bar bg-success"
              role="progressbar"
              :style="{ width: progress + '%' }"
            >
              {{ progress }}%
            </div>
          </div>

          <!-- Area Accordion -->
          <div v-for="section in sections" :key="section.id" class="card mb-3">
            <div class="card-header p-3">
              <button
                class="btn btn-link btn-block text-left"
                @click="toggle(section)"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 class="mb-1 text-primary">
                      📍 SECTION {{ section.section }}
                      <span
                        class="badge ml-2"
                        :class="
                          section.category_type == 'cleaning'
                            ? 'badge-success'
                            : 'badge-warning'
                        "
                      >
                        {{
                          section.category_type == "cleaning"
                            ? "🧹 CLEANING"
                            : "🏢 NON CLEANING"
                        }}
                      </span>
                    </h5>
                    <small class="text-muted">
                      {{ section.areas.length }}
                      Area Coverage
                    </small>
                  </div>

                  <div>
                    <span
                      class="badge"
                      :class="
                        section.is_completed ? 'badge-success' : 'badge-warning'
                      "
                    >
                      {{ section.is_completed ? "DONE" : "PENDING" }}
                    </span>
                    <br />
                    <small v-if="section.updated_at" class="text-success">
                      Last update:
                      {{ section.updated_at }}
                    </small>
                  </div>
                </div>
              </button>
            </div>

            <div v-show="opened === section.section" class="card-body">
              <div class="feedback-block">
                <h5>🏢 Area Coverage</h5>

                <div class="list-group">
                  <div
                    class="list-group-item"
                    v-for="area in section.areas"
                    :key="area.id"
                  >
                    <strong> Floor {{ area.area_floor }} </strong>

                    •

                    {{ formatType(area.area_type) }}

                    •

                    {{ area.area_name }}
                  </div>
                </div>
              </div>

              <div class="feedback-block mt-4">
                <h5>👨‍🔧 HK Team</h5>

                <p class="mb-0" v-if="section.hk_list.length > 0">
                  {{ formatHKList(section.hk_list) }}
                </p>
                <p v-else>-</p>
              </div>

              <!-- New Rating Block -->
              <div class="row mt-4">
                <div
                  :class="
                    section.category_type == 'cleaning'
                      ? 'col-md-6'
                      : 'col-md-12'
                  "
                >
                  <!-- Individual-->
                  <div class="feedback-block">
                    <h5>👤 Penilaian Individu</h5>

                    <div
                      v-for="question in individualQuestions"
                      :key="question.key"
                      class="mb-4"
                    >
                      <label>
                        {{ question.label }}
                      </label>

                      <star-rating
                        :value="section.feedback.individu[question.key]"
                        @change="
                          updateSectionRating(
                            section.section,
                            'individu',
                            question.key,
                            $event
                          )
                        "
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-6"
                  v-if="section.category_type == 'cleaning'"
                >
                  <!-- Area-->
                  <div class="feedback-block">
                    <h5>🧹 Penilaian Area</h5>

                    <div
                      v-for="question in areaQuestions"
                      :key="question.key"
                      class="mb-4"
                    >
                      <label>
                        {{ question.label }}
                      </label>

                      <star-rating
                        :value="section.feedback.area[question.key]"
                        @change="
                          updateSectionRating(
                            section.section,
                            'area',
                            question.key,
                            $event
                          )
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- END New Rating Block -->

              <div class="row mt-4">
                <div class="col-md-12">
                  <div class="feedback-block mt-4">
                    <h5>👨‍💼 PIC</h5>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Masukkan Nama PIC"
                      v-model="section.feedback.pic"
                    />
                    <small class="text-muted">
                      Nama PIC yang memberikan penilaian
                    </small>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-md-12">
                  <div class="feedback-block mt-4">
                    <h5>📝 Catatan</h5>

                    <textarea
                      class="form-control"
                      rows="4"
                      v-model="section.feedback.note"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-md-12">
                  <button
                    class="btn btn-success btn-block"
                    @click="submitSection(section)"
                  >
                    Submit Feedback Section
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rating Help Modal -->
    <div
      v-if="showRatingHelp"
      class="popup popup-lg d-flex align-items-center justify-content-center"
      style="position: fixed; inset: 0; z-index: 9999"
    >
      <div class="content bg-white p-4 rounded" style="width: 500px">
        <div class="d-flex justify-content-between mb-3">
          <h5>Penjelasan Rating</h5>
          <button class="btn btn-sm btn-danger" @click="showRatingHelp = false">
            ✕
          </button>
        </div>

        <p>
          <strong>⭐ 1 - Sangat Buruk</strong><br />
          Banyak kekurangan, perlu tindakan segera
        </p>

        <p>
          <strong>⭐ 2 - Buruk</strong><br />
          Kurang memuaskan
        </p>

        <p>
          <strong>⭐ 3 - Cukup</strong><br />
          Standar, masih bisa ditingkatkan
        </p>

        <p>
          <strong>⭐ 4 - Baik</strong><br />
          Memuaskan
        </p>

        <p>
          <strong>⭐ 5 - Sangat Baik</strong><br />
          Sangat bersih & sesuai ekspektasi
        </p>
      </div>
    </div>
    <!-- End Rating Help Modal -->

    <!-- Modal Feedback Period -->
    <div v-if="showPeriodModal" class="feedback-period-overlay">
      <div class="feedback-period-modal">
        <!-- HEADER -->

        <div class="feedback-header">
          <h3>📋 Feedback Survey</h3>
        </div>

        <!-- CONTRACT INFO -->

        <div class="feedback-contract-info">
          <div>
            <strong> Contract </strong>

            <br />

            {{ selectedContract.contract_number }}
          </div>

          <div>
            <strong> Client </strong>

            <br />

            {{ selectedContract.client.name }}
          </div>

          <div>
            <strong> Contract Period </strong>

            <br />

            {{ selectedContract.start_date }}

            -

            {{ selectedContract.end_date }}
          </div>
        </div>

        <!-- MONTH LIST -->

        <div class="month-history">
          <div
            class="month-card"
            v-for="month in feedbackHistory"
            :key="month.month"
            :class="{
              completed: month.completed,
              selected: selectedFeedbackMonths.includes(month.month),
            }"
            @click="toggleFeedbackMonth(month)"
          >
            <!-- @click="continueFeedback()" -->
            <div class="month-icon">
              {{ month.completed ? "🟢" : "🔴" }}
            </div>

            <div class="month-label">
              {{ month.label }}
            </div>

            <div class="month-status">
              {{ month.completed ? "Already Evaluated" : "Pending" }}
            </div>

            <div class="month-progress">{{ month.progress }}%</div>

            <div class="progress">
              <div
                class="progress-bar"
                :style="{
                  width: month.progress + '%',
                }"
              ></div>
            </div>
          </div>
        </div>

        <div class="feedback-footer">
          <button class="btn btn-default" @click="closeFeedbackPeriod()">
            Close
          </button>

          <button
            class="btn btn-primary"
            @click="continueFeedback"
            :disabled="selectedFeedbackMonths.length == 0"
          >
            Lanjut Penilaian
          </button>
        </div>
      </div>
    </div>
    <!-- End Modal Feedback Period -->

    <!-- Modal Generate PDF -->
    <div class="feedback-period-overlay" v-if="showPdfModal">
      <div class="feedback-period-modal">
        <div class="feedback-header">
          <h3>Generate PDF</h3>
        </div>

        <div class="month-history">
          <div
            class="month-card"
            v-for="month in pdfMonths"
            :key="month.month"
            :class="{
              completed: month.completed,
            }"
            @click="generatePdf(month.month)"
          >
            <!-- @click="continueFeedback()" -->
            <div class="month-icon">
              {{ month.completed ? "🟢" : "🔴" }}
            </div>

            <div class="month-label">
              {{ month.label }}
            </div>

            <div class="month-status">
              {{ month.completed ? "Already Evaluated" : "Pending" }}
            </div>

            <div class="month-progress">{{ month.progress }}%</div>

            <div class="progress">
              <div
                class="progress-bar"
                :style="{
                  width: month.progress + '%',
                }"
              ></div>
            </div>
          </div>
        </div>

        <div class="feedback-footer">
          <button class="btn btn-default" @click="showPdfModal = false">
            Close
          </button>
        </div>
      </div>
    </div>
    <!-- End Modal Generate PDF -->
  </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";

export default {
  name: "ReportFeedbackSurveyIndex",

  components: {
    DatePicker,
    StarRating: {
      data() {
        return { hover: 0 };
      },
      props: {
        value: {
          type: Number,
          default: 0,
        },
      },
      methods: {
        select(n) {
          this.$emit("change", n);
        },
      },
      template: `
        <div>
          <span
            v-for="n in 5"
            :key="n"
            @click="select(n)"
            @mouseover="hover = n"
            @mouseleave="hover = 0"
            :class="['star', (n <= value || n <= hover) ? 'active' : '']"
          >
            ★
          </span>
        </div>
      `,
    },
  },

  data() {
    return {
      selectedContract: null,
      opened: null,
      showRatingHelp: false,
      isSubmitting: false,
      isUpdateMode: false,
      contracts: [],
      sections: [],
      individualQuestions: [
        {
          key: "sopan_santun",
          label: "Sopan Santun",
        },
        {
          key: "kerapihan_penampilan",
          label: "Kerapihan Penampilan",
        },
        {
          key: "cara_bersikap_dan_berbicara",
          label: "Cara Bersikap & Berbicara",
        },
      ],

      areaQuestions: [
        {
          key: "kebersihan_lantai",
          label: "Kebersihan Lantai",
        },
        {
          key: "kebersihan_dinding",
          label: "Kebersihan Dinding",
        },
        {
          key: "kebersihan_atap",
          label: "Kebersihan Atap",
        },
        {
          key: "kebersihan_kaca",
          label: "Kebersihan Kaca",
        },
        {
          key: "kebersihan_toilet",
          label: "Kebersihan Toilet",
        },
        {
          key: "kebersihan_pantry",
          label: "Kebersihan Pantry",
        },
        {
          key: "kebersihan_umum",
          label: "Kebersihan Umum",
        },
        {
          key: "kebersihan_aksesoris",
          label: "Kebersihan Aksesoris",
        },
      ],

      feedbackPeriod: {
        start_date: "",

        end_date: "",
      },
      showPeriodModal: false,
      feedbackHistory: [],
      // selectedFeedbackMonth: "",
      selectedFeedbackMonths: [],
      completedSelectedMonths: [],
      pdfContract: null,
      pdfMonths: [],
      showPdfModal: false,
    };
  },

  computed: {
    selectedMonthsText() {
      return this.selectedFeedbackMonths
        .map((m) => {
          const found = this.feedbackHistory.find((x) => x.month === m);

          return found ? found.label : m;
        })
        .join(" • ");
    },
    newSelectedMonths() {
      return this.selectedFeedbackMonths.filter(
        (x) => !this.completedSelectedMonths.includes(x)
      );
    },
    progress() {
      const total = this.sections.length;
      // const filled = this.sections.filter((a) => a.ratings.overall > 0).length;
      const filled = this.sections.filter((a) => a.is_completed).length;

      return total ? Math.round((filled / total) * 100) : 0;
    },
    groupedAreas() {
      const grouped = {};

      this.sections.forEach((area) => {
        if (!grouped[area.section]) {
          grouped[area.section] = [];
        }
        grouped[area.section].push(area);
      });

      // console.log("grouped", grouped);

      return grouped;
    },
  },

  created() {
    const roleUserPrivilegesName = ["root", "hrd nasional"];

    if (
      !roleUserPrivilegesName.includes(
        localStorage.getItem("userPrivilegesName")
      )
    ) {
      this.isClient =
        localStorage.getItem("userIdPrivileges") == 14 ? true : false;
      this.branchId = localStorage.getItem("userBranchId");
    } else {
      this.isRoot = true;
    }

    this.fetchContracts();
  },
  methods: {
    formatMonth(month) {
      const found = this.feedbackHistory.find((m) => m.month === month);

      return found ? found.label : month;
    },
    async fetchContracts() {
      try {
        const response = await axios.get("/contract/need-feedback");
        this.contracts = response.data.data;

        // console.log(JSON.stringify(this.contracts));
      } catch (error) {
        console.error(error);
      }
    },
    async loadHistory(contractId) {
      const result = await axios.get(
        this.$store.state.api_resource +
          "api/report/contract/feedback-period/" +
          contractId
      );

      this.feedbackHistory = result.data.data || [];
    },
    closeFeedbackPeriod() {
      this.showPeriodModal = false;
      this.selectedContract = null;
    },
    async openFeedbackPeriod(contract) {
      this.selectedContract = contract;
      this.feedbackPeriod = {
        start_date: "",
        end_date: "",
      };
      this.showPeriodModal = true;
      await this.loadHistory(contract.id);
    },
    backToPeriod() {
      this.showPeriodModal = true;
    },
    continueFeedback() {
      this.showPeriodModal = false;

      this.completedSelectedMonths = this.selectedFeedbackMonths.filter(
        (selected) => {
          const found = this.feedbackHistory.find((m) => m.month === selected);

          return found && found.completed;
        }
      );

      this.selectContract(this.selectedContract, this.selectedFeedbackMonths);
    },
    selectContract(contract, months) {
      // console.log("selectContract", contract, months);
      this.selectedContract = contract;

      const grouped = {};

      // console.log(contract.areas[0]);

      contract.areas.forEach((area) => {
        // console.log("area", area);
        // create section
        if (!grouped[area.section]) {
          grouped[area.section] = {
            section: area.section,
            category_type: area.category_type,
            is_completed: false,
            employee_loaded: false,
            areas: [],
            hk_list: [],
            feedback: {
              pic: "",

              individu: {
                sopan_santun: 0,
                kerapihan_penampilan: 0,
                cara_bersikap_dan_berbicara: 0,
              },

              area: {
                kebersihan_lantai: 0,
                kebersihan_dinding: 0,
                kebersihan_atap: 0,
                kebersihan_kaca: 0,
                kebersihan_toilet: 0,
                kebersihan_pantry: 0,
                kebersihan_umum: 0,
                kebersihan_aksesoris: 0,
              },

              note: "",
            },
          };
        }

        grouped[area.section].areas.push(area);
      });

      this.sections = Object.values(grouped);

      this.populateExistingFeedback(contract, months);
    },
    async selectFeedbackMonth(month) {
      this.selectedFeedbackMonth = month.month;

      this.showPeriodModal = false;

      await this.selectContract(this.selectedContract, month.month);
    },
    toggleFeedbackMonth(month) {
      const index = this.selectedFeedbackMonths.indexOf(month.month);

      if (index > -1) {
        this.selectedFeedbackMonths.splice(index, 1);
      } else {
        this.selectedFeedbackMonths.push(month.month);
      }
    },
    populateExistingFeedback(contract, months) {
      // ==========================================
      // Tidak ada feedback sama sekali
      // ==========================================
      if (
        !contract.feedbacks ||
        !Array.isArray(contract.feedbacks) ||
        contract.feedbacks.length === 0
      ) {
        return;
      }

      // ==========================================
      // Ambil feedback yang termasuk bulan terpilih
      // ==========================================
      const selectedFeedbacks = contract.feedbacks.filter((feedback) =>
        months.includes(feedback.feedback_month)
      );

      if (selectedFeedbacks.length === 0) {
        console.log("No existing feedback found for selected months.");
        return;
      }

      // ==========================================
      // Populate per feedback
      // ==========================================
      selectedFeedbacks.forEach((feedback) => {
        if (!feedback.feedback_sections) {
          return;
        }

        feedback.feedback_sections.forEach((savedSection) => {
          const targetSection = this.sections.find(
            (s) => parseInt(s.section) === parseInt(savedSection.section)
          );

          if (!targetSection) {
            return;
          }

          // ======================================
          // PIC
          // ======================================
          targetSection.feedback.pic = savedSection.pic || "";

          // ======================================
          // NOTE
          // ======================================
          targetSection.feedback.note = savedSection.note || "";

          // ======================================
          // STATUS
          // ======================================
          targetSection.is_completed = true;

          targetSection.updated_at = savedSection.updated_at;

          // ======================================
          // Reset rating sebelum populate
          // ======================================
          Object.keys(targetSection.feedback.individu).forEach((key) => {
            targetSection.feedback.individu[key] = 0;
          });

          Object.keys(targetSection.feedback.area).forEach((key) => {
            targetSection.feedback.area[key] = 0;
          });

          // ======================================
          // Populate score
          // ======================================
          savedSection.scores.forEach((score) => {
            if (
              score.category === "individu" &&
              targetSection.feedback.individu.hasOwnProperty(score.dimension)
            ) {
              targetSection.feedback.individu[score.dimension] = score.rating;
            }

            if (
              score.category === "area" &&
              targetSection.feedback.area.hasOwnProperty(score.dimension)
            ) {
              targetSection.feedback.area[score.dimension] = score.rating;
            }
          });
        });
      });
    },
    formatType(type) {
      return type.charAt(0).toUpperCase() + type.slice(1);
    },
    getStatusIcon(month) {
      if (month.progress === 100) {
        return "🟢";
      }

      if (month.progress > 0) {
        return "🟡";
      }

      return "🔴";
    },
    // toggle(id) {
    //   this.opened = this.opened === id ? null : id;
    // },
    async toggle(section) {
      this.opened = this.opened === section.section ? null : section.section;

      if (this.opened !== section.section) {
        return;
      }

      if (section.employee_loaded) {
        return;
      }

      const areaIds = section.areas.map((x) => x.id);

      await this.loadSectionEmployees(section, areaIds);
    },
    formatHKList(hkList) {
      return hkList.map((item) => item.fullname).join(", ");
    },
    async loadSectionEmployees(section, areaIds) {
      try {
        const response = await axios.post(
          "/report/contract/section-employees",
          {
            area_ids: areaIds,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        this.$set(section, "hk_list", response.data.data);
        this.$set(section, "employee_loaded", true);
      } catch (err) {
        console.error(err);
      }
    },
    updateRating(areaId, key, value) {
      // console.log("UPDATE:", areaId, key, value);

      const area = this.areas.find((a) => a.id === areaId);
      if (area) {
        this.$set(area.ratings, key, value);
      }
    },
    updateSectionRating(sectionNumber, category, key, value) {
      const section = this.sections.find((s) => s.section === sectionNumber);

      if (!section) return;

      if (section) {
        this.$set(section.feedback[category], key, value);
      }
    },
    async openPdfPeriod(contract) {
      this.pdfContract = contract;

      try {
        const result = await axios.get(
          this.$store.state.api_resource +
            "api/report/contract/feedback-period/" +
            contract.id
        );

        // hanya yang completed
        this.pdfMonths = result.data.data.filter((x) => x.progress > 0);

        this.showPdfModal = true;
      } catch (err) {
        console.log(err);
      }
    },
    async generatePdf(month) {
      const token = localStorage.getItem("jwt-token");

      window.open(
        this.$store.state.api_resource +
          "api/feedback/pdf/" +
          this.pdfContract.id +
          "/" +
          month +
          "/" +
          token,
        "_blank"
      );
    },
    async submitSection(section) {
      if (this.isSubmitting) return;

      this.isSubmitting = true;

      // ===== BUILD PAYLOAD =====
      const payload = {
        contract_id: this.selectedContract.id,
        feedback_months: this.selectedFeedbackMonths,
        section: section.section,
        feedback: section.feedback,
      };

      // console.log("PAYLOAD:", JSON.stringify(payload));

      try {
        const response = await axios.post(
          "/report/contract/submit-feedback",
          payload,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (response.data.status) {
          alert("Feedback berhasil dikirim");
          this.selectedContract = null;
          this.areas = [];
        }
      } catch (error) {
        if (error.response) {
          alert(error.response.data.message);
        } else {
          alert("Terjadi kesalahan.");
        }
      } finally {
        this.isSubmitting = false;
        this.fetchContracts();
      }
    },
  },
};
</script>

<style>
button[disabled] {
  cursor: not-allowed !important;
  opacity: 0.7;
}

.card-body {
  position: relative;
  z-index: 1;
}

.star {
  font-size: 22px;
  cursor: pointer !important;
  color: #dee2e6 !important;
  margin-right: 4px;
  display: inline-block;
  position: relative;
  z-index: 2;
  pointer-events: auto !important;
}

.star.active {
  color: #ffc107 !important;
}

.star:hover {
  color: #ffb300 !important;
  transform: scale(1.1) !important;
}

.feedback-period-header {
  text-align: center;
  margin-bottom: 20px;
}

.feedback-period-header small {
  color: #888;
  font-size: 13px;
  text-transform: uppercase;
}

.feedback-period-header h3 {
  margin-top: 5px;
  color: #1f2937;
  font-weight: 600;
}

.feedback-warning-card {
  display: flex;
  background: #fff8e6;
  border-left: 6px solid #f59e0b;
  padding: 18px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.warning-icon {
  font-size: 42px;
  margin-right: 20px;
}

.warning-content {
  flex: 1;
}

.warning-content h4 {
  margin-top: 0;
  color: #b45309;
  font-weight: bold;
}

.warning-content ul {
  padding-left: 18px;
  margin-bottom: 5px;
}

.feedback-block {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 15px;
  height: 100%;
}

.feedback-block h5 {
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 10px;
  margin-bottom: 15px;
  font-weight: 600;
}
.card-header {
  background: #f8f9fa;
}

.list-group-item {
  border-radius: 0 !important;
}
.timeline {
  border-left: 3px solid #00a8b5;
  padding-left: 15px;
}

.timeline li {
  margin-bottom: 15px;
}

.feedback-period-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .feedback-period-modal {
  width: 1000px;
  max-height: 80vh;
  background: white;
  border-radius: 10px;
  overflow: hidden;
} */

.feedback-period-modal {
  width: 1000px;
  max-width: 95vw;

  max-height: 90vh;

  background: #fff;
  border-radius: 10px;

  display: flex;
  flex-direction: column;

  overflow: hidden;
}

.feedback-header {
  background: #00a8b5;
  color: white;
  padding: 15px 20px;
}

.feedback-header,
.feedback-contract-info,
.feedback-footer {
  flex-shrink: 0;
}

.feedback-contract-info {
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #ddd;
}

/* .month-history {
  padding: 20px;
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
} */

.month-history {
  flex: 1;

  overflow-y: auto;

  padding: 20px;

  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  min-height: 0;
}

.month-card {
  width: 160px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
  text-align: center;
}

.month-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.month-card.completed {
  background: #ecfdf3;
  border-color: #22c55e;
}

.month-card.selected {
  border: 2px solid #2196f3;
  background: #e3f2fd;
}

.month-icon {
  font-size: 24px;
  margin-bottom: 10px;
}

.month-label {
  font-weight: bold;
}

.month-status {
  font-size: 12px;
  color: #777;
  margin-top: 5px;
}

.feedback-footer {
  border-top: 1px solid #ddd;
  padding: 15px;
  text-align: right;
}

.month-progress {
  margin-top: 10px;
  font-size: 12px;
  font-weight: bold;
}

.progress {
  height: 8px;
  margin-top: 5px;
  background: #eee;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  background: #00a8b5;
  height: 100%;
}

.feedback-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 15px;
  z-index: 10;
}

@media (max-width: 992px) {
  .feedback-period-modal {
    width: 95vw;
  }
}
</style>